// let env = process.env.NODE_ENV;
// console.log(env);
// let ApiServer = (ApiServer = '');
let ApiServer = process.env.VUE_APP_API;

const Rest = {
  common: {
    getNewsList: () => {
      return `${ApiServer}/common/getNewsList`;
    },
    checkOnlineStatus: () => {
      return `${ApiServer}/common/checkOnlineStatus`;
    },
    getReferenceData: () => {
      return `${ApiServer}/common/getReferenceData`;
    },
  },
  payment: {
    bookingRepose: () => {
      return `${ApiServer}/payment/bookingRepose`;
    },
    bookingLight: () => {
      return `${ApiServer}/payment/bookingLight`;
    },
  },
  order: {
    getOrderStatus: () => {
      return `${ApiServer}/order/getOrderStatus`;
    },
    getBookingList: () => {
      return `${ApiServer}/order/bookingList`;
    },
    getBookingInfo: () => {
      return `${ApiServer}/order/bookingInfo`;
    },
  },
};
export default Rest;
